import React, { useState } from "react";

const Search = ({ search }) => {
  const [searchValue, setSearchValue] = useState("");

  const updateSearchText = (e) => {
    let searchCode = e.target.value;
    setSearchValue(searchCode);
  };
  return (
    <div className="storage-search-input search-input input-group rounded-shadow ">
      <input
        id="searchTerm"
        type="text"
        className="form-control"
        placeholder="Search for stored items"
        value={searchValue}
        onChange={(e) => updateSearchText(e)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            search(searchValue);
          }
        }}
      />
      <i className="icon-omni-search" onClick={() => search(searchValue)}></i>
    </div>
  );
};

export default Search;
